import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodigoInfraccionService {

  
  private apiUrl =  `${environment.apiUrl}/api/codigoinfraccion`; 

  constructor(private http: HttpClient) { }

  getAllCodigoInfraccion(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl, { withCredentials: true }).pipe(
      catchError(error => {
        console.error('Error al obtener los códigos de infracción:', error);
        return throwError(() => error);
      })
    );
  }
}
